import { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import useIacTableStore from "views/Account/IacManagement/components/Table/useIacTableStore";
import TableCellGroup from "ds/components/Table/Row/CellGroup";

import { RenderGroupRowCellProps } from "../../../../ListLayout/TableGroupRow";
import IacManagementTableCell from "../Cell";

type IacManagementGroupCellProps = RenderGroupRowCellProps &
  Pick<TableCellContentProps, "children" | "actions" | "role">;

const IacManagementGroupCell = ({
  cellId,
  isFirst,
  children,
  fetchDataLoading,
  loadResources,
  isGroupOpen,
  actions,
  role,
}: IacManagementGroupCellProps) => {
  const isFirstColumnPinned = useIacTableStore((state) => state.isFirstColumnPinned);
  const stickyLeft = isFirst && isFirstColumnPinned;

  return (
    <IacManagementTableCell id={cellId} role={role} stickyLeft={stickyLeft} actions={actions}>
      <TableCellGroup
        isActive={isFirst}
        loading={fetchDataLoading}
        onPress={loadResources}
        isGroupOpen={isGroupOpen}
        title="Load Resources"
      >
        {children}
      </TableCellGroup>
    </IacManagementTableCell>
  );
};

export default IacManagementGroupCell;
